import React from 'react';
import PropTypes from 'prop-types';
import Modal from "react-modal";
import css from "./VirtualKioskSettings.scss";
import Footer from "common/Footer";
import StyledButton from "common/StyledButton";
import Header from "common/Header";
import Switch from "common/Switch";
import Icon from 'SF/MaterialIcon';
import VirtualCheckInAvailability from "./VirtualCheckInAvailability";

// Virtual Kiosk settings modal for Tenant Admins
const VirtualKioskSettings = (props) => {
    Modal.setAppElement(document.getElementById("main-center"));

    const error = () =>
        props.error !== '' &&
        <div className={css["container-error-msg"]}>
            <Icon icon="error"/>
            <div aria-live="polite" className={css["error-text"]}>{props.error}</div>
        </div>;

    return (
        <Modal
            isOpen={props.isOpen}
            onRequestClose={props.closeModal}
            overlayClassName={css["overlay"]}
            className={css["modal"]}
            shouldCloseOnOverlayClick={false}
            contentLabel={`Virtual Kiosk Settings for ${props.kioskName}`}>
            <div className={css["container"]}>
                <Header closeModal={props.closeModal} />
                <div className={css["modal-heading"]}>
                    <h1>Virtual Kiosk Settings</h1>
                    <div className={css["kiosk-name"]}>Kiosk Name: {props.kioskName}</div>
                </div>
                {error()}
                <div className={css["content"]}>
                    <div className={css['virtual-check-in']}>
                        <span className={css['check-in-header']}>Virtual Check-in</span>
                        <p>
                            Available only for Services that display in the {sfTenant.language.getWord('successNetwork')}.
                            When enabled, students can launch and check-in to the Kiosk from that Service
                            within {sfTenant.language.getWord('Starfish')}.
                            There are additional settings available below when enabled.
                        </p>
                        <div className={css['enable-virtual-check-in']}>
                            <Switch id="enableVirtualCheckIn"
                                    aria-label="Allow virtual check in"
                                    checked={props.virtualCheckInEnabled}
                                    onChange={(checked) => props.setVirtualCheckInEnabled(checked)} />
                            <label htmlFor="enableVirtualCheckIn" className={css["label"]}>Allow Virtual Check-in</label>
                        </div>
                    </div>
                    <VirtualCheckInAvailability {...props} />
                </div>
                <Footer
                    primaryButton={
                        <StyledButton disabled={props.disableSave} aria-disabled={props.disableSave} onClick={props.saveSettings}>
                            Save Changes
                        </StyledButton>
                    }
                    secondaryButton={
                        <StyledButton asLink onClick={props.closeModal}>
                            Cancel Changes
                        </StyledButton>
                    }
                />
            </div>
        </Modal>
    );
}

VirtualKioskSettings.propTypes = {
    isOpen: PropTypes.bool,
    kioskName: PropTypes.string,
    error: PropTypes.string,
    disableSave: PropTypes.bool,
    virtualCheckInEnabled: PropTypes.bool,
    setVirtualCheckInEnabled: PropTypes.func,
    saveSettings: PropTypes.func,
    closeModal: PropTypes.func,
    ...VirtualCheckInAvailability.props
}

export default VirtualKioskSettings;
